/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Lehdistötiedotteet - CamAPS FX',
    titleMeta: 'Lehdistötiedotteet - CamAPS FX',
    descriptionMeta: 'Uusimmat lehdistötiedotteet ja uutiset CamAPS FX:stä.',
    keywords: 'camaps lehdistötiedotteet, camaps uutiset, diabetesteknologian uutiset',
    localeMeta: 'fi_fi',

    bannerTitle: 'Lehdistötiedotteet',
    bannerSubtitle: 'Pysy ajan tasalla viimeisimmistä ilmoituksistamme',

    contactText: 'Lehdistökyselyissä ota yhteyttä osoitteeseen <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Kaikki lehdistötiedotteet julkaistaan englannin kielellä.',

    download: 'Lataa',
    showMore: 'Näytä lisää',
    showLess: 'Näytä vähemmän',
};

